module.exports = __webpack_public_path__ + "static/gianluca-593695f0f93073f95d0864ebad1d72a0.png";